// extracted by mini-css-extract-plugin
export default {"input":"Input_input__yvX7v alude-input","container":"Input_container__d1f-r"};